import { Component, OnInit,ViewChild,HostListener  } from '@angular/core';
import { SiteService } from '../site/site.service';
import { UserManagementService } from '../user-management/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute,Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {
  buildNavbarMenuItems,
  buildNavbarNotificationConfig,
  buildProfileMenuItems,
  NavbarMenuItem,
  NavbarNotificationConfig,
} from '../shared-navbar/navbar-config';
import { executeNavbarAction } from '../shared-navbar/navbar-actions';
@Component({
    selector: 'app-multisite-user-nav',
    templateUrl: './multisite-user-nav.component.html',
    styleUrls: ['./multisite-user-nav.component.css'],
    standalone: false
})
export class MultiSiteUserNavComponent implements OnInit {
  private storage = environment.storage;
  @ViewChild('content') content;
  @ViewChild('picker') picker: any;
  public dateRange: any;
  public isCollapsed = false;
  public isMenuCollapsed = true;
  public userDetail: any;
  allocatedSite:any;
  public siteinfo:any;
  pdfurl:any;
  sitename:any;
  periodicDateRange : any;
  modelref : any;
  data: any;
  loading = 0;
  currentsite = '';
  currentsitename = '';
  avatarSrc = './assets/images/avathar.jpg';
  constructor( private router: Router,private userService: UserManagementService,private siteService: SiteService,private modalService: NgbModal,private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const allSites = this.userService.getSiteDetail();
    this.userDetail = this.userService.getUserDetail();
    this.siteinfo=this.userService.getSiteDetail();
    this.currentsite=this.userService.getCurrentSite();
    this.currentsitename=this.userService.getCurrentSitename();
    if(allSites?.length){
      this.allocatedSite = this.currentsite;
      this.pdfurl = this.siteService.getPDFUrl(this.siteinfo[0].sitepfd);
      this.sitename=this.currentsitename;
    }
   
  }
  

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    // ('Back button pressed');
    // Add your custom logic here
   //  (this.router.url)
  }

  get currentUrl(){
    return this.router.url;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  get userRle() {
      return this.userDetail?.role;
    }

  get showPrimaryMenus(): boolean {
    return this.currentUrl !== '/';
  }

  get menuItems(): NavbarMenuItem[] {
    return buildNavbarMenuItems('multisite-user', {
      userRole: this.userDetail?.role,
      allocatedSite: this.allocatedSite,
      hasPfd: !!this.siteinfo?.[0]?.sitepfd,
      showPrimaryMenus: this.showPrimaryMenus,
    });
  }

  get profileMenuItems(): NavbarMenuItem[] {
    return buildProfileMenuItems('multisite-user', {});
  }

  get notificationConfig(): NavbarNotificationConfig {
    return buildNavbarNotificationConfig('multisite-user', {
      userRole: this.userDetail?.role ?? this.userDetail?.user_role,
    });
  }

  onNavbarAction(actionId: string): void {
    void executeNavbarAction(actionId, {
      router: this.router,
      userService: this.userService,
    });
  }

}
